import createLucideIcon from '../createLucideIcon';

const Mail = createLucideIcon('MailIcon', [
  [
    'rect',
    { x: '2', y: '4', width: '20', height: '16', rx: '2', key: 'izxlao' },
  ],
  ['path', { d: 'm22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7', key: '1ocrg3' }],
]);

export default Mail;
